import { get, put, post } from "../services/HttpService";
import { axiosIns } from "../services";
import { accountNumberValidationRegex, bankBranchValidationRegex, ifscValidationRegex, beneficiaryNameRegex, size_greater_than } from '../app_methods';


export class MerchantBankAccount {
    constructor(merchantBankAccountObject = {}) {
        this.set(merchantBankAccountObject);
    };


    static validations = {
        "id": [],
        "uuid": [],
        "merchant": [],
        "name_on_bank": [
            { required: true, message: "Name on bank is required." },
            { pattern: beneficiaryNameRegex(),message: "Please enter a valid name." },
            { max: 60, message: "Name on bank can be of maximum 60 characters" }
        ],
        "bank_name":[
            { required: true, message: "Bank Name is required." },
            { pattern: beneficiaryNameRegex(),message: "Please enter a valid bank name." },
            { max: 60, message: "Bank Name can be of maximum 60 characters" }
        ],
        "account_number": [
            { required: true, message: "Account Number is required." },
            { pattern: accountNumberValidationRegex(),message: "No Space or Special Characters Allowed."},
            { min: 3, message: "Must be atleast 3 characters long" },
            { max: 25, message: "Account Number can be of maximum 25 characters." }
        ],
        "account_ifsc": [
            {pattern: ifscValidationRegex(), message:"Please enter a valid IFSC." },
            { required: true, message: "IFSC is required." },
            { len:11, message: "IFSC must be of 11 characters." }
        ],
        "bank_branch": [
            { required: true, message: "Bank Branch is required." },
            { pattern: bankBranchValidationRegex(),message: "Invalid bank branch format."},
        ],
        "cancelled_cheque": [ 
            {
                validator: (rule, value, callback) => {
                    if (!value) {
                        callback();
                        return;
                    }
                    const file = value.file;
                    if(file){
                        size_greater_than(file, 1000000) ? callback(true) : callback();
                    }
                },
                message: "File size cannot exceed 1 MB"
            }, 
            { required: true, message: "Cancelled Cheque is required." },
        ],
        "other_document": [{
            validator: (rule, value, callback) => {
                if (!value) {
                    callback();
                    return;
                }
                const file = value.file;
                if(file){
                    size_greater_than(file, 1000000) ? callback(true) : callback();
                }
            },
            message: "File size cannot exceed 1 MB"
        },],
    };


    /**
         * @memberof MerchantBankAccount
         * @type API
         * @returns Promise
         */
    static list = (queryData = {}, config = {}) => {
        return get(`v1/internal/merchant_bank_account_list/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof MerchantBankAccount
     * @type API
     * @returns Promise
     */
     save = (queryData = {}) => {
        let formData = new FormData();
        formData.append('name_on_bank',queryData.name_on_bank);
        formData.append('bank_name',queryData.bank_name);
        formData.append('account_number',queryData.account_number);
        formData.append('account_ifsc',queryData.account_ifsc);
        formData.append('bank_branch',queryData.bank_branch);
        formData.append('cancelled_cheque',queryData.cancelled_cheque && queryData.cancelled_cheque.file ? queryData.cancelled_cheque.file : '');
        formData.append('other_document',queryData.other_document && queryData.other_document.file ? queryData.other_document.file : '');
        formData.append("key", queryData.key);
        if (queryData.id){
            formData.append('id',queryData.id);
            return post(`v1/internal/update_bank_account/${queryData.id}/`, formData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
        } 
        return post(`v1/internal/create_bank_account/`, formData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };


    /**
     * @memberof MerchantBankAccount
     * @type API
     * @returns Promise
     */
     get_kyc_url = (queryData) => {
        return get(`v1/internal/bank_accounts/doc_url/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof MerchantBankAccount
     * @type API
     * @returns Promise
     */
     validate_ifsc = (queryData) => {
        return get(`v1/internal/bank_accounts/validate_ifsc/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof MerchantBankAccount
     * @type Setter Method
     * @takes MerchantBankAccount Params
     * @returns void
     */
     set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };

    /**
     * @memberof MerchantBankAccount
     * @type Getter Method
     * @returns MerchantBankAccount
     */
    get = () => {
        return {
            id: this.id,
            uuid: this.uuid,
            merchant:this.merchant,
            name_on_bank:this.name_on_bank,
            bank_name:this.bank_name,
            account_number:this.account_number,
            account_ifsc:this.account_ifsc,
            bank_branch:this.bank_branch,
            cancelled_cheque:this.cancelled_cheque,
            other_document:this.other_document,
            is_verified:this.is_verified,
        }
    };
};